// extracted by mini-css-extract-plugin
module.exports = {"infos":"MoreInfoModal_infos__3gP5r","info":"MoreInfoModal_info__Hf0M0","right":"MoreInfoModal_right__1s9O3"};